import { mergeMap } from 'rxjs/operators';
import get from 'lodash.get';
import { of } from 'rxjs';
import * as Api from '../../../../store/bulk/update/bulk.update.api';
import { BulkActions } from '../../../../enums/bulk-actions';
import { AsyncJobHelper } from '../../../../services/async-job-helper';

const makeApiCallWithIds = (job) => {
  const { bulkUpdateTypeData, ids, model } = job;

  const request = {
    packingSlipTemplateId: get(model, 'templates.packingSlipTemplateId'),
    shipmentEmailTemplateId: get(model, 'templates.shipmentEmailTemplateId'),
    deliveryEmailTemplateId: get(model, 'templates.deliveryEmailTemplateId'),
    filters: [...bulkUpdateTypeData.requestFilter(ids)],
  };

  return Api.bulkUpdateTemplates(request).pipe(
    mergeMap((data) => {
      const foldedData = AsyncJobHelper.foldMultiJobResponse(data);
      return of(foldedData);
    }),
  );
};

const makeApiCallWithJobGuid = (job) => {
  const {
    model,
    jobData: { bulkUpdateJobGuid },
  } = job;

  const request = {
    packingSlipTemplateId: get(model, 'templates.packingSlipTemplateId'),
    shipmentEmailTemplateId: get(model, 'templates.shipmentEmailTemplateId'),
    deliveryEmailTemplateId: get(model, 'templates.deliveryEmailTemplateId'),
    bulkUpdateJobGuid,
  };

  return Api.bulkTemplatesUpdate(request).pipe(
    mergeMap((data) => {
      return of(data);
    }),
  );
};

export const templates = {
  id: 'templates',
  applicableBulkActions: [BulkActions.emailTemplate, BulkActions.packingSlipTemplate],

  handler: (job) => {
    const {
      jobData: { bulkUpdateJobGuid },
    } = job;

    const makeApiCall$ = bulkUpdateJobGuid ? makeApiCallWithJobGuid : makeApiCallWithIds;

    return makeApiCall$(job);
  },
};
